import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api } from "../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { ProductsAdmin } from "../components/admin/ProductsAdmin";
import { OrdersAdmin } from "../components/admin/OrdersAdmin";
import { WalletsAdmin } from "../components/admin/WalletsAdmin";

export default function Admin() {
  const nav = useNavigate();
  const [ok, setOk] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(() => setOk(true)).catch(() => nav("/admin/login"));
  }, [nav]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("gifts_admin_token");
    nav("/admin/login");
  };

  if (!ok) return null;
  return (
    <main className="mx-auto max-w-6xl px-5 py-10" data-testid="admin-panel">
      <div className="mb-8 flex items-center justify-between">
        <h1 className="font-display text-3xl font-semibold text-white">Admin</h1>
        <button onClick={logout} data-testid="admin-logout-button" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white"><LogOut className="h-4 w-4" /> Log out</button>
      </div>
      <Tabs defaultValue="products">
        <TabsList className="bg-white/[0.04]">
          <TabsTrigger value="products" data-testid="admin-tab-products">Products</TabsTrigger>
          <TabsTrigger value="orders" data-testid="admin-tab-orders">Orders</TabsTrigger>
          <TabsTrigger value="wallets" data-testid="admin-tab-wallets">Wallets</TabsTrigger>
        </TabsList>
        <TabsContent value="products" className="mt-6"><ProductsAdmin /></TabsContent>
        <TabsContent value="orders" className="mt-6"><OrdersAdmin /></TabsContent>
        <TabsContent value="wallets" className="mt-6"><WalletsAdmin /></TabsContent>
      </Tabs>
    </main>
  );
}
